import axiosClient from "utils/axios";
import { ApiList, ApiOptionList, ApiResponse } from "types/api.types";

export interface LeaveType {
  id: number;
  name: string;
  code?: string | null;
}

export const getLeaveTypes = async ({
  page = 1,
  limit = 20,
  search,
}: {
  page?: number;
  limit?: number;
  search?: string;
} = {}) => {
  const response = await axiosClient.get<ApiResponse<ApiList<LeaveType[]>>>(
    "/leave-types",
    { params: { page, limit, search: search || undefined } },
  );
  return response.data;
};

export const getLeaveTypeOptions = async ({
  query,
  page = 1,
  limit = 20,
}: {
  query?: string;
  page?: number;
  limit?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      "/leave-types/options",
      {
        params: {
          query: query?.trim() || undefined,
          page,
          limit,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.warn("GET /leave-types/options failed, using /leave-types:", err);
    const fallback = await getLeaveTypes({
      search: query || undefined,
      page,
      limit,
    });
    const rows = (fallback.data?.rows ?? []) as LeaveType[];
    const options: ApiOptionList["rows"] = rows.map((t) => ({
      value: t.id,
      label: t.name,
    }));
    const lim = limit;
    const hasMore =
      rows.length === lim && (fallback.data?.totalItems ?? 0) > page * lim;
    return {
      success: fallback.success,
      message: fallback.message,
      data: { rows: options, hasMore },
    } satisfies ApiResponse<ApiOptionList>;
  }
};
